import * as actionTypes from "./actionTypes";
import axiosRequest from "../../axios-request/request.methods";
import { useDispatch } from "react-redux";

export const fetchEnachDataRule = (enachRule) => {
  console.log("ENACHRULES----->", enachRule);
  return {
    type: actionTypes.FETCHENACHRULE,
    enachRule: enachRule,
  };
};

export const fetchStateFail = (errMsg) => {
  return {
    type: actionTypes.FETCH_ENACH_FAIL,
    error: errMsg,
  };
};

export const enachRulesData = (proposalId) => {
  return async (dispatch) => {
    try {
      const res = await axiosRequest.get(`user/getenachRules/${proposalId}`);
      console.log("res---->", res);
      return dispatch(fetchEnachDataRule(res));
    } catch (error) {
      return dispatch(fetchStateFail(error));
    }
  };
};
